import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class GDataService {
  private dataTransferSubject = new Subject<any>()
  dataTransferObservable = this.dataTransferSubject.asObservable();

  push(data: any) {
    this.dataTransferSubject.next(data);
  }
}
